gsap.registerPlugin(ScrollTrigger);

// nav background on scroll
const nav = document.getElementById('nav');
ScrollTrigger.create({
  start: 'top -80',
  onUpdate: self => nav.classList.toggle('is-scrolled', self.scroll() > 80)
});

// hero entrance
gsap.timeline({ delay: .2 })
  .to('.hero__text', { opacity: 1, y: 0, duration: 1.1, ease: 'power3.out' });

// generic scroll reveals
document.querySelectorAll('[data-reveal]').forEach(el => {
  if (el.closest('.hero')) return;
  gsap.to(el, {
    opacity: 1,
    y: 0,
    duration: 1,
    ease: 'power3.out',
    scrollTrigger: { trigger: el, start: 'top 85%' }
  });
});

// staggered reveal for grids
['.product-grid .product-card'].forEach(sel => {
  const items = document.querySelectorAll(sel);
  if (!items.length) return;
  gsap.to(items, {
    opacity: 1,
    y: 0,
    duration: .9,
    ease: 'power3.out',
    stagger: .12,
    scrollTrigger: { trigger: items[0], start: 'top 88%' }
  });
});


// hero slider — cycle between the 2 hero images
(function () {
  var slides = document.querySelectorAll('#hero-slider .hero__slide');
  var dots = document.querySelectorAll('.hero__dots .hero__dot');
  if (slides.length < 2) return;
  var i = 0;
  function show(n) {
    slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === n); });
    dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === n); });
    i = n;
  }
  dots.forEach(function (d, idx) {
    d.addEventListener('click', function () { show(idx); });
  });
  setInterval(function () { show((i + 1) % slides.length); }, 5000);
})();


// mobile hamburger menu
(function () {
  var burger = document.getElementById('nav-burger');
  var menu = document.getElementById('nav-mobile-menu');
  if (!burger || !menu) return;
  burger.addEventListener('click', function () {
    var open = menu.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  menu.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () {
      menu.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
    });
  });
})();
